<div class="container{{ isModal || fullWidth() ? '-fluid' : '' }} border-secondary">
  <div class="row">
    <div class="col p-0">
      <ul
        ngbNav
        #nav="ngbNav"
        class="nav-tabs"
        [destroyOnHide]="false"
        [activeId]="activeId()"
        (activeIdChange)="onActiveIdChange($event)"
      >
        @for (it of items; track it.id; let index = $index) {
          <li [ngbNavItem]="it.id">
            <a ngbNavLink [class]="it.t.headerClass ?? ''" (click)="loadTemplate(it.t)">
              @if (isTemplateRef(it.t.header)) {
                <ng-container [ngTemplateOutlet]="it.t.header" [ngTemplateOutletContext]="it.t.context"> </ng-container>
              } @else {
                {{ it.t.header }}
              }
            </a>

            <ng-template ngbNavContent>
              @if (it.t.loaded) {
                <ng-template [ngTemplateOutlet]="it.t.template" [ngTemplateOutletContext]="it.t.context"> </ng-template>
              }
            </ng-template>
          </li>
        }
      </ul>
      <div [ngbNavOutlet]="nav" class="bg-white p-3"></div>
    </div>
  </div>
</div>
